import clsx from 'clsx';
import { useRouteMatch } from 'react-router';

import Presets from './Presets';
import { EditIcon } from './EditIcon';
import { useModal } from '../../hooks';
import Conversation from './Conversation';
import { usePresets } from './usePresets';
import { jessica } from '../../utilities';
import { EditorModal } from '../../components';

type AgentComponentProps = { agentId: string };

const AgentComponent: React.FC<AgentComponentProps> = ({ agentId }) => {
  const { isOpened, onClose, onOpen } = useModal();
  const { loading, data } = usePresets(agentId);
  if (loading) return null;

  return (
    <div className="flex flex-col justify-center items-center w-full">
      <EditorModal
        initialContent={jessica.getText()}
        open={isOpened}
        onClose={onClose}
        onSave={text => {
          jessica.setText(text);
          onClose();
        }}
      />

      <Conversation agentId={agentId}>
        <div className="relative">
          <Presets
            presets={data || []}
            onClick={text => jessica.setText(text)}
          />
          <div
            onClick={onOpen}
            className={clsx(
              'absolute top-[-9.5rem] left-[-1.5rem] cursor-pointer',
              'bg-content border border-active hover:bg-active p-sm rounded-full'
            )}
          >
            <EditIcon />
          </div>
        </div>
      </Conversation>
    </div>
  );
};

const AgentPage = () => {
  const { params } = useRouteMatch<{ id: string }>();
  const agentId = params?.id;

  if (!agentId) return null;
  return <AgentComponent key={agentId} agentId={agentId} />;
};

export default AgentPage;
